<template>
    <div>
        <card-header title="Registrations" :subheader="type" icon="fa-users"></card-header>

        <card-body>
            <card-list>
                <search-list-item/>
                <subheader-list-item title="Registrations" icon="fa-users"/>
                <rmc-registration-tile :card="card" :registration="reg" :active="false" v-for="reg in registrations"/>
            </card-list>
            <infinite-loading @infinite="loadRegistrations" v-if="registrations.length">
                <div slot="no-more"></div>
                <div slot="no-results">No Records Found</div>
            </infinite-loading>
        </card-body>

        <card-footer>
            Showing <strong>{{ registrations.length }}</strong> <span v-if="paging.count !== paging.total"> of <strong>{{ paging.count }}</strong> {{ type }} </span>of <strong>{{ paging.total }}</strong> Total Registrations
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import CardList from "@/TIER/components/CardList";
    import CardSubheader from "@/TIER/components/CardSubheader";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";

    import RmcRegistrationTile from "@/components/rmc/RmcRegistrationTile";

    import {client as http} from "@/http_client";

    export default {
        name: "RMCRegistrationList",
        props: ['card', 'child', 'props'],
        components: {CardFooter, RmcRegistrationTile, CardHeader, CardBody, SearchListItem, CardList, CardSubheader, SubheaderListItem},
        data() {
            return {
                registrations: [],
                type: '',
                paging: {
                    total: 0,
                    start: 0,
                    count: 0
                }
            };
        },
        methods: {
            loadRegistrations: function($state) {
                let q = (this.props.query) ? this.props.query : 'null';
                //
                http.get('rmc/registrations/' + this.props.confId + '/' + this.props.type + '/' + q + '/' + this.paging.start + '/100').then(response => {
                    this.registrations.push(...response.data.registrations);
                    this.paging.total = response.data.total;
                    this.paging.count = response.data.count;
                    this.paging.start += response.data.registrations.length;

                    if ($state) {
                        if (response.data.count <= this.registrations.length) {
                            console.log('complete!');
                            $state.complete();
                        } else {
                            console.log('loaded');
                            $state.loaded();
                        }
                    }

                    this.$emit('loading', false);
                });
            }
        },
        watch: {
            'props.type': function() {
                this.registrations = [];
                this.paging = {
                    total: 0,
                    start: 0,
                    count: 0
                };

                this.$emit('loading', true);
                this.loadRegistrations();

                switch (this.props.type) {
                    case 'all':
                        this.type = null;
                        this.$emit('title', 'All Registrations');
                        break;
                    case 'pending':
                        this.type = 'Pending';
                        this.$emit('title', 'Pending Registrations');
                        break;
                }
            }
        },
        mounted: function() {
            this.loadRegistrations();
        }
    };
</script>
